import React, { createContext, useContext } from 'react'
import { Chat } from '../../global/chatSettingsConfig'
import { useBookmarkList } from '../../hooks/chatHooks'

export const BookmarksContext = createContext()

export const useBookmarks = () => useContext(BookmarksContext)

export function BookmarksProvider({ children }) {
  const [bookmarks, refetchBookmarks, requestState] = useBookmarkList()
  const privateChatRooms = bookmarks?.filter((bookmark) => bookmark.jid.startsWith('private_')) || []
  const publicChatRooms =
    bookmarks?.filter(
      (bookmark) =>
        !bookmark.jid.startsWith(Chat.Settings.PRIVATE_CHAT_ROOM_PREFIX) && !/(S|V).{3}-.{3}@/.exec(bookmark.jid)
    ) || []
  const sessionChatRooms = bookmarks?.filter((bookmark) => /S.{3}-.{3}@/.exec(bookmark.jid)) || []
  const vendorChatRooms = bookmarks?.filter((bookmark) => /V.{3}-.{3}@/.exec(bookmark.jid)) || []

  return (
    <BookmarksContext.Provider
      value={{
        bookmarks: [...privateChatRooms, ...publicChatRooms, ...sessionChatRooms, ...vendorChatRooms],
        privateChatRooms,
        publicChatRooms,
        sessionChatRooms,
        vendorChatRooms,
        refetchBookmarks,
        requestState,
      }}
    >
      {children}
    </BookmarksContext.Provider>
  )
}
